import {
  SET_COSMETOLOGIC_FEES_BY_COSMETOLOGIST_FILTERS,
  SET_DAILY_CASH_CLOSING_FILTERS,
  SET_DAILY_SALES_FILTERS,
  SET_EXPENSES_BY_BRANCH_FILTERS,
  SET_GENERAL_APPOINTMENT_FILTERS,
  SET_GENERAL_COSMETOLOGIC_FEES_FILTERS,
  SET_GENERAL_CUSTOMERS_FILTERS,
  SET_GENERAL_EXPENSES_FILTERS,
  SET_GENERAL_INVENTORY_FILTERS,
  SET_GENERAL_SCHEDULE_APPOINTMENTS_FILTERS,
  SET_INDIVIDUAL_COMMISSION_MEDICAL_REPORT_FILTERS,
  SET_MEDICAL_COMMISSION_BY_BRANCH_FILTERS,
  SET_MONTHLY_SALES_FILTERS,
  SET_APPOINTMENT_CONFIRMATION_PERCENTAGE_REPORT_BY_BRANCH_FILTERS,
  SET_PROFITABILTY_BY_BRANCH_FILTERS,
  SET_STOCK_BY_BRANCH_FILTERS,
} from '../types';

const initialState = {
  generalInventoryFilters: {},
  stockByBranchfilters: {},
  generalExpensesFilters: {},
  expensesByBranchFilters: {},
  generalCustomersFilters: {},
  generalAppointmentFilters: {},
  generalCosmetologicFeesFilters: {},
  cosmetologicFeesByCosmetologistFilters: {},
  medicalCommissionByBranchFilters: {},
  generalScheduleAppointmentsFilters: {},
  individualCommissionMedicalFilters: {},
  appointmentConfirmationPercentageReportByBranchFilters: {},
  dailySalesFilters: {},
  monthlySalesFilters: {},
  dailyCashClosingFilters: {},
  profitabiltyByBranchFilters: {},
};

export default function individualReports(state = initialState, action) {
  switch (action.type) {
    case SET_GENERAL_INVENTORY_FILTERS:
      return {
        ...state,
        generalInventoryFilters: {
          ...state.generalInventoryFilters,
          ...action.payload,
        },
      };
    case SET_STOCK_BY_BRANCH_FILTERS:
      return {
        ...state,
        stockByBranchfilters: {
          ...state.stockByBranchfilters,
          ...action.payload,
        },
      };
    case SET_GENERAL_EXPENSES_FILTERS:
      return {
        ...state,
        generalExpensesFilters: {
          ...state.generalExpensesFilters,
          ...action.payload,
        },
      };
    case SET_EXPENSES_BY_BRANCH_FILTERS:
      return {
        ...state,
        expensesByBranchFilters: {
          ...state.expensesByBranchFilters,
          ...action.payload,
        },
      };
    case SET_GENERAL_CUSTOMERS_FILTERS:
      return {
        ...state,
        generalCustomersFilters: {
          ...state.generalCustomersFilters,
          ...action.payload,
        },
      };
    case SET_GENERAL_APPOINTMENT_FILTERS:
      return {
        ...state,
        generalAppointmentFilters: {
          ...state.generalAppointmentFilters,
          ...action.payload,
        },
      };
    case SET_GENERAL_COSMETOLOGIC_FEES_FILTERS:
      return {
        ...state,
        generalCosmetologicFeesFilters: {
          ...state.generalCosmetologicFeesFilters,
          ...action.payload,
        },
      };
    case SET_COSMETOLOGIC_FEES_BY_COSMETOLOGIST_FILTERS:
      return {
        ...state,
        cosmetologicFeesByCosmetologistFilters: {
          ...state.cosmetologicFeesByCosmetologistFilters,
          ...action.payload,
        },
      };
    case SET_MEDICAL_COMMISSION_BY_BRANCH_FILTERS:
      return {
        ...state,
        medicalCommissionByBranchFilters: {
          ...state.medicalCommissionByBranchFilters,
          ...action.payload,
        },
      };
    case SET_GENERAL_SCHEDULE_APPOINTMENTS_FILTERS:
      return {
        ...state,
        generalScheduleAppointmentsFilters: {
          ...state.generalScheduleAppointmentsFilters,
          ...action.payload,
        },
      };
    case SET_INDIVIDUAL_COMMISSION_MEDICAL_REPORT_FILTERS:
      return {
        ...state,
        individualCommissionMedicalFilters: {
          ...state.individualCommissionMedicalFilters,
          ...action.payload,
        },
      };
    case SET_APPOINTMENT_CONFIRMATION_PERCENTAGE_REPORT_BY_BRANCH_FILTERS:
      return {
        ...state,
        appointmentConfirmationPercentageReportByBranchFilters: {
          ...state.appointmentConfirmationPercentageReportByBranchFilters,
          ...action.payload,
        },
      };
    case SET_DAILY_SALES_FILTERS:
      return {
        ...state,
        dailySalesFilters: {
          ...state.dailySalesFilters,
          ...action.payload,
        },
      };
    case SET_MONTHLY_SALES_FILTERS:
      return {
        ...state,
        monthlySalesFilters: {
          ...state.monthlySalesFilters,
          ...action.payload,
        },
      };
    case SET_DAILY_CASH_CLOSING_FILTERS:
      return {
        ...state,
        dailyCashClosingFilters: {
          ...state.dailyCashClosingFilters,
          ...action.payload,
        },
      };
    case SET_PROFITABILTY_BY_BRANCH_FILTERS:
      return {
        ...state,
        profitabiltyByBranchFilters: {
          ...state.profitabiltyByBranchFilters,
          ...action.payload,
        },
      };
    default:
      return state;
  }
}
